import React from "react";
import {
    Background,
    Card2FA,
    DividerStyle,
    DividerWrapper,
    IllustrationSignin,
    LogoImage,
    TextAnyProblem,
} from "./index.style";
import { Flex } from "@fluentui/react-northstar";
import { BASE_URL_ILLUSTRATIONS } from "../../constants";
import FormOTP from "./components/FormOTP/FormOTP";
import DialogGetHelp from "./components/DialogGetHelp/DialogGetHelp";
import useOTP from "./hooks/useOTP";
import withGuestOnly from "../../HOC/withGuestOnly";

const Auth2FA = () => {
    const {
        otp,
        functions,
        inputRefs,
        disable_btn_verify_otp,
        mutations,
        count_down,
        hashed_mail,
        alert,
        error,
        errorMessage,
    } = useOTP();

    return (
        <Background
            fill
            column
            hAlign="center"
            vAlign="center"
            onPaste={functions.handlePaste}
        >
            <Card2FA hAlign="center" vAlign="center" column gap="gap.medium">
                {/* logo */}
                <LogoImage src={"/logo/Logo_yeetch.svg"} />
                {/* illustration */}
                <IllustrationSignin
                    src={`${BASE_URL_ILLUSTRATIONS}/auth/pana.svg`}
                />
                {/* form OTP */}
                <FormOTP
                    otp={otp}
                    functions={functions}
                    inputRefs={inputRefs}
                    disable_btn_verify_otp={disable_btn_verify_otp}
                    mutations={mutations}
                    count_down={count_down}
                    hashed_mail={hashed_mail}
                    alert={alert}
                    error={error}
                    errorMessage={errorMessage}
                />
                {/* divider */}
                <DividerWrapper>
                    <DividerStyle />
                </DividerWrapper>
                {/* footer */}
                <Flex vAlign="center">
                    <TextAnyProblem content="Un problème ?" />
                    <DialogGetHelp />
                </Flex>
            </Card2FA>
        </Background>
    );
};

export default withGuestOnly(Auth2FA);
